import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import PrimaryIDType from "./PrimaryIDType"

export default function PrimaryIDTypesGetObservable(): Observable<PrimaryIDType[]> {
  return ObservableFromFetch<PrimaryIDType[]>("FFOrderClientFileMaintenance/GetPrimaryIDTypes")
}

export function PoolPrimaryIDTypesGetObservable(): Observable<PrimaryIDType[]> {
  return ObservableFromFetch<PrimaryIDType[]>("FFOrderPoolDefinition/GetPrimaryIDTypes")
}

